import React from 'react'

export default function SendButton({enabled}) {
    return (
      <button className={`contact__button ${!enabled ? 'disabled' : ''}`} type='submit' disabled={!enabled}>
        Send
      </button>
    )
}
